import React, { useEffect, useState } from 'react'
import { Checkbox, Drawer } from 'antd'

import { usePet } from '../../modules'

const NewCompany = ({ toggle, visible, onPerform, company }) => {
    const [name, setName] = useState()
    const [address, setAddress] = useState()
    const [phone, setPhone] = useState()
    const [email, setEmail] = useState()
    const [country, setCountry] = useState('Kenya')
    const [contactPerson, setContactPerson] = useState()
    const [contactPersonPhone, setContactPersonPhone] = useState()
    const [shaEnabled, setShaEnabled] = useState(false)
    const [shaBiometricEnabled, setShaBiometricEnabled] = useState(false)
    const [shaBaseUrl, setShaBaseUrl] = useState()
    const [shaClientId, setShaClientId] = useState()
    const [shaClientSecret, setShaClientSecret] = useState()
    const [shaFacilityFrCode, setShaFacilityFrCode] = useState()
    const [shaEkycProviderId, setShaEkycProviderId] = useState()
    const [kephLevel, setKephLevel] = useState()
    const editing = Boolean(company?._id)

    useEffect(() => {
        if (!visible) return;

        setName(company?.name ?? '')
        setAddress(company?.address ?? '')
        setPhone(company?.phone ?? '')
        setEmail(company?.email ?? '')
        setCountry(company?.country ?? 'Kenya')
        setContactPerson(company?.contactPerson ?? '')
        setContactPersonPhone(company?.contactPersonPhone ?? '')
        setShaEnabled(Boolean(company?.shaEnabled))
        setShaBiometricEnabled(Boolean(company?.shaBiometricEnabled))
        setShaBaseUrl(company?.shaBaseUrl ?? '')
        setShaClientId('')
        setShaClientSecret('')
        setShaFacilityFrCode(company?.shaFacilityFrCode ?? '')
        setShaEkycProviderId(company?.shaEkycProviderId ?? '')
        setKephLevel(company?.kephLevel ?? '')
    }, [company, visible])

    const close = () => {
        toggle()
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'address':
                setAddress(e.target.value)
                break

            case 'phone':
                setPhone(e.target.value)
                break

            case 'email':
                setEmail(e.target.value)
                break

            case 'country':
                setCountry(e.target.value)
                if (e.target.value?.trim()?.toLowerCase() !== 'kenya') {
                    setShaEnabled(false)
                    setShaBiometricEnabled(false)
                    setShaBaseUrl(undefined)
                    setShaClientId(undefined)
                    setShaClientSecret(undefined)
                    setShaFacilityFrCode(undefined)
                    setShaEkycProviderId(undefined)
                    setKephLevel(undefined)
                }
                break

            case 'contactPerson':
                setContactPerson(e.target.value)
                break

            case 'contactPersonPhone':
                setContactPersonPhone(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif(`Company has been ${editing ? 'updated' : 'added'}`, ops('success'))
        
        setTimeout(close, 300)
    }

    const payload = {
        ...(editing ? { id: company?._id } : {}),
        name,
        address,
        phone,
        email,
        country,
        contactPerson,
        contactPersonPhone,
        shaEnabled,
        shaBiometricEnabled,
        shaBaseUrl,
        ...(shaFacilityFrCode?.trim() ? { shaFacilityFrCode } : {}),
        ...(shaEkycProviderId?.trim() ? { shaEkycProviderId } : {}),
        ...(shaClientId?.trim() ? { shaClientId } : {}),
        ...(shaClientSecret?.trim() ? { shaClientSecret } : {}),
        ...(kephLevel ? { kephLevel: Number(kephLevel) } : {}),
    }

    const [{ loading }, execute] = usePet(editing ? 'editCompany' : 'newCompany', payload, { notify: true, callback: onComplete, manual: true })

    const kenyaFacility = country?.trim()?.toLowerCase() === 'kenya'

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">{editing ? 'Save Changes' : 'Create Company'}</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">{editing ? 'Company Details' : 'New Company'}</p>
            <div className="divide-y divide-light-gray-400">
                <div>
                    <div>
                        <p className="font-bold my-3">Company Details</p>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Company Name
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-name" 
                                    type="text" 
                                    value={ name }
                                    name="name"
                                    placeholder="Hisani Company" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Address <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-address" 
                                    type="text" 
                                    value={ address }
                                    name="address"
                                    placeholder="Centenary House, Westlands" />
                            </div>
                        </div>
                        <p className="font-bold my-3">Contact Information</p>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Phone
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-phone" 
                                    type="text" 
                                    value={ phone }
                                    name="phone"
                                    placeholder="07XXXXXXXX" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Email <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-email" 
                                    type="text" 
                                    value={ email }
                                    name="email"
                                    placeholder="company@domain.com" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mt-6 md:mt-0 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-country">
                                    Country
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-country" 
                                    type="text" 
                                    value={ country }
                                    name="country"
                                    placeholder="Kenya" />
                            </div>
                        </div>
                        <p className="font-bold my-3">Contact Person</p>
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Contact Person
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-role-contactPerson" 
                                    type="text" 
                                    value={ contactPerson }
                                    name="contactPerson"
                                    placeholder="Evans Kimani" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Contact Person Phone
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-contact-phone" 
                                    type="text" 
                                    value={ contactPersonPhone }
                                    name="contactPersonPhone"
                                    placeholder="07XXXXXXXX" />
                            </div>
                        </div>
                        <div className="mt-6">
                            <p className="font-bold my-3">Kenya SHA Integration</p>
                            <div className="w-full px-3 mb-4">
                                <Checkbox checked={ shaEnabled } disabled={ !kenyaFacility } onChange={ e => {
                                    const checked = e.target.checked
                                    setShaEnabled(checked)
                                    if (!checked) setShaBiometricEnabled(false)
                                } }>
                                    Enable Kenya SHA integration for this facility
                                </Checkbox>
                                {
                                    !kenyaFacility &&
                                    <p className="text-xs text-gray-500 mt-2 mb-0">SHA setup is only available for facilities in Kenya.</p>
                                }
                            </div>
                            {
                                kenyaFacility && shaEnabled &&
                                <div className="flex flex-wrap mt-3 -mx-3">
                                    {
                                        editing &&
                                        <div className="w-full px-3 mb-4">
                                            <div className="rounded border border-blue-200 bg-blue-50 px-3 py-3 text-sm text-blue-900">
                                                <p className="font-semibold mb-1">Saved SHA credentials</p>
                                                <p className="mb-1">Client ID: {company?.shaClientIdConfigured ? 'Configured' : 'Not yet configured'}</p>
                                                <p className="mb-0">Client Secret: {company?.shaClientSecretConfigured ? 'Configured' : 'Not yet configured'}</p>
                                            </div>
                                        </div>
                                    }
                                    {
                                        editing &&
                                        <div className="w-full px-3 mb-4">
                                            <div className="rounded border border-emerald-200 bg-emerald-50 px-3 py-3 text-sm text-emerald-900">
                                                <p className="font-semibold mb-1">Biometric / eKYC status</p>
                                                <p className="mb-1">Biometric enabled: {company?.shaBiometricEnabled ? 'Yes' : 'No'}</p>
                                                <p className="mb-1">FR code: {company?.shaFacilityFrCode ?? 'Not yet set'}</p>
                                                <p className="mb-1">eKYC provider ID: {company?.shaEkycProviderId ?? 'Not yet set'}</p>
                                                <p className="mb-0">KEPH level: {company?.kephLevel ?? 'Not yet set'}</p>
                                            </div>
                                        </div>
                                    }
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-sha-base-url">
                                            SHA Base URL
                                        </label>
                                        <input 
                                            onChange={ e => setShaBaseUrl(e.target.value) }
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-sha-base-url" 
                                            type="text" 
                                            value={ shaBaseUrl }
                                            placeholder="https://example-hie-uat/api-root" />
                                    </div>
                                    <div className="w-full px-3 my-4">
                                        <Checkbox checked={ shaBiometricEnabled } onChange={ e => setShaBiometricEnabled(e.target.checked) }>
                                            Enable biometric / eKYC SHA operations
                                        </Checkbox>
                                        <p className="text-xs text-gray-500 mt-2 mb-0">
                                            Leave this off for OTP-only SHA rollout. Turn it on only when the facility is ready for biometric/eKYC SHA flows.
                                        </p>
                                    </div>
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-keph-level">
                                            Facility KEPH Level <span className="text-gray-500 text-xs normal-case italic">(Optional but required for SHA per-diem)</span>
                                        </label>
                                        <select
                                            id="grid-keph-level"
                                            value={ kephLevel ?? '' }
                                            onChange={ e => setKephLevel(e.target.value) }
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white">
                                            <option value="">Select KEPH level</option>
                                            {[2, 3, 4, 5, 6].map(level => <option key={ level } value={ level }>{`Level ${level}`}</option>)}
                                        </select>
                                    </div>
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-sha-client-id">
                                            SHA Client ID
                                        </label>
                                        <input 
                                            onChange={ e => setShaClientId(e.target.value) }
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-sha-client-id" 
                                            type="text" 
                                            value={ shaClientId }
                                            placeholder={ editing ? 'Leave blank to keep current client ID' : 'Facility SHA client ID' } />
                                    </div>
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-sha-client-secret">
                                            SHA Client Secret
                                        </label>
                                        <input 
                                            onChange={ e => setShaClientSecret(e.target.value) }
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-sha-client-secret" 
                                            type="password" 
                                            value={ shaClientSecret }
                                            placeholder={ editing ? 'Leave blank to keep current client secret' : 'Facility SHA client secret' } />
                                    </div>
                                    {
                                        shaBiometricEnabled &&
                                        <>
                                            <div className="w-full md:w-1/2 px-3 mt-6 md:mt-6 mb-6 md:mb-0">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-sha-fr-code">
                                                    SHA Facility FR Code
                                                </label>
                                                <input 
                                                    onChange={ e => setShaFacilityFrCode(e.target.value) }
                                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                                    id="grid-sha-fr-code" 
                                                    type="text" 
                                                    value={ shaFacilityFrCode }
                                                    placeholder="Facility Registry code" />
                                            </div>
                                            <div className="w-full md:w-1/2 px-3 mt-6 md:mt-6 mb-6 md:mb-0">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-sha-ekyc-provider">
                                                    SHA eKYC Provider ID <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                                                </label>
                                                <input 
                                                    onChange={ e => setShaEkycProviderId(e.target.value) }
                                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                                    id="grid-sha-ekyc-provider" 
                                                    type="text" 
                                                    value={ shaEkycProviderId }
                                                    placeholder="As provided by SHA / DHA" />
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default NewCompany
